import _ from "lodash";
import api from "@/api/cloud";
import config from "@/../public/config.json";


const state = () => ({
	items: [],
	current: null,
	resident: null,
	personalDevices: []
});

const getters = {
	items: state => state.items || [],
	current: state => state.current,
	resident: state => state.resident,
	personalDevices: state => state.personalDevices
		// _.get(state.resident, "Associations", [])
		// 	.filter(({ type }) =>
		// 		config.personalDeviceTypes.includes(type)
		// 	),
};

const mutations = {
	SET_ITEMS(state, items) {
		state.items = items;
	},

	SET_CURRENT(state, current) {
		state.current = current;
	},

	SET_RESIDENT(state, resident) {
		state.resident = resident;
	},

	ADD_ASSOC(state, association) {
		state.resident.Associations.push(association);
	},

	RMV_ASSOC(state, id) {
		state.resident.Associations = state.resident.Associations.filter(item => item.id !== id);
	}
};

const actions = {
	async getItems({ commit, getters }, refresh = false) {
		let items = getters.items;
		if (!items.length || refresh) {
			items = await api.getRoomMoveTickets();
			commit("SET_ITEMS", items);
		}
		return items;
	},

	async getResident({ commit, getters }, id) {

		let items = getters.items;
		let ticket = _.find(items, ['_id', id]);

		if(!ticket)
		{
			ticket = await api.getRoomMoveTicket(id);
		}

		commit("SET_RESIDENT", ticket._owner);
		return ticket._owner;
	},

	// async addPersonalDevice({ getters, commit }, { identifier, name, type } = {}) {
	// 	let association;

	// 	try {
	// 		association = await api.findAssociationByIdentifier(identifier);
	// 	} catch (e) {
	// 		if (e.response.status !== 404) throw e;
	// 	}

	// 	if (!association) {
	// 		association = await api.addAssociation({ identifier, name, type });
	// 	}

	// 	const resp = await api.addAssociationUser(getters.resident.guid, association.id);
	// 	commit("ADD_ASSOC", association);
	// 	return resp;
	// },

	// async updatePersonalDevice({ __ }, { id, identifier, name } = {}) {
	// 	return api.updateAssociation(id, { identifier, name });
	// },

	// async removePersonalDevice({ getters, commit }, { id }) {
	// 	const resp = await api.removeAssociationUser(getters.resident.guid, id);
	// 	commit("RMV_ASSOC", id);
	// 	return resp;
	// },

	async closeTicket({ getters, commit }) {
		const resident = _.cloneDeep(getters.resident);
		const ticket = getters.current;
		ticket._status = 'closed';
		const resp = await api.closeTicket(ticket);
		commit("SET_RESIDENT", resident);
		return resp;
	},

	async "close-Move In"({ dispatch }, data) {
		return dispatch("addSystemToResident", data);
	},

	async "close-Room Move"({ dispatch }, data) {
		await dispatch("removeSystemFromResident", data);
		return dispatch("addSystemToResident", data);
	},

	async "close-Move Out"({ dispatch }, data) {
		await dispatch("removeSystemFromResident", data);
		return dispatch("removeUserRoomProps");
	},

	async addSystemToResident({ getters }, { newSys }) {
		// Move/Move In
		if (!newSys) return;
		await api.addUserSystem(getters.resident._id, newSys.id);
		return api.setUserLocation(getters.resident._id, newSys.name);
	},

	async removeSystemFromResident({ getters }, { oldSys }) {
		// Move/Move Out
		if (!oldSys) return;
		return api.removeUserSystem(getters.resident._id, oldSys.id);
	},

	async removeUserRoomProps({ getters }) {
		// Move Out
		await api.archiveUser(getters.resident._id);
		return true;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
